import { render, staticRenderFns } from "./Insumo.vue?vue&type=template&id=d6712e46"
import script from "./Insumo.vue?vue&type=script&lang=js"
export * from "./Insumo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports